/* global google */
import { useEffect, useRef } from 'react';
import { MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer';
import { mapChromeShell } from '../../../styles/mapChromeShell';

function getClusterRadius() {
    const width = window.innerWidth;
    if (width < 768) return 120;   // スマホ
    if (width < 1024) return 100;  // タブレット
    return 80;                     // PC
}

function createClusterRenderer() {
    return {
        render({ count, position }) {
            const el = document.createElement('div');
            el.className = mapChromeShell.clusterBadge;
            el.textContent = count;

            const marker = new google.maps.marker.AdvancedMarkerElement({
                position,
                content: el,
                zIndex: 1000 + count,
            });
            return marker;
        },
    };
}

export function useMarkerClusterer(map) {
    const clustererRef = useRef(null);

    useEffect(() => {
        if (!map) return;

        clustererRef.current = new MarkerClusterer({
            map,
            renderer: createClusterRenderer(),
            algorithm: new SuperClusterAlgorithm({
                maxZoom: 22,
                minPoints: 5,
                radius: getClusterRadius(),
            }),
            onClusterClick: () => {},
        });

        return () => {
            clustererRef.current?.clearMarkers();
            clustererRef.current?.setMap(null);
            clustererRef.current = null;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map]);

    // 画面リサイズ時に clusterer を再生成
    useEffect(() => {
        const handleResize = () => {
            if (!clustererRef.current || !map) return;
            const markers = clustererRef.current.markers;
            clustererRef.current.clearMarkers();
            clustererRef.current.setMap(null);
            clustererRef.current = new MarkerClusterer({
                map,
                renderer: createClusterRenderer(),
                algorithm: new SuperClusterAlgorithm({
                    maxZoom: 22,
                    minPoints: 5,
                    radius: getClusterRadius(),
                }),
                onClusterClick: () => {},
            });
            if (markers?.length) clustererRef.current.addMarkers(markers);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [map]);

    return clustererRef;
}
